export var IDENTIFIER_SWITCH = 'switch';
